import { apiClient } from './api';
import { 
  StartComicSessionRequest, 
  ComicSessionStartResponse,
  ComicCharacterResponse,
  ComicScriptResponse,
  ComicIterateRequest,
  ComicIterateResponse
} from '../models/comicBook';

export class ComicBookService {
  static async startSession(request: StartComicSessionRequest): Promise<ComicSessionStartResponse> {
    const response = await apiClient.post('/api/comicbook/session/start', request);
    return response.data;
  }

  static async addCharacter(sessionId: string, character: { name: string; description?: string }): Promise<ComicCharacterResponse> {
    const response = await apiClient.post(`/api/comicbook/session/${sessionId}/character/add`, character);
    return response.data;
  }

  static async generateScript(sessionId: string, issueNumber: number = 1): Promise<ComicScriptResponse> {
    const response = await apiClient.post(`/api/comicbook/session/${sessionId}/script/generate`, {
      issueNumber
    });
    return response.data;
  }

  static async iterate(sessionId: string, request: ComicIterateRequest): Promise<ComicIterateResponse> {
    const response = await apiClient.post(`/api/comicbook/session/${sessionId}/iterate`, request);
    return response.data;
  }
}

export default ComicBookService;